























































import { Component, Vue, Prop } from 'vue-property-decorator';
import { SummaryPayAuthorityModel } from '@/models/payauthority';
import { DATA } from '@/config/data';

@Component
export default class FilterBox extends Vue {
    private eventEmit = {
        eventFilterChange: 'eventFilterChange'
    };
    @Prop({default: null})
    private summaryOrder!: SummaryPayAuthorityModel;

    selectedStatus = { value: -1, name: 'Tất cả', color: '#fff' };
    searchText = '';

    get listStatus() {
        const status = DATA.complainStatusList;
        return status;
    }

    onclickStatus(status: any) {
        this.selectedStatus = status;
        this.$emit(this.eventEmit.eventFilterChange, {
            searchText: this.searchText,
            status: this.selectedStatus
        });
    }

    onTextSearchChange() {
        this.$emit(this.eventEmit.eventFilterChange, {
            searchText: this.searchText,
            status: this.selectedStatus
        });
    }

    getTotalOrder(status, format = true) {
            let total = 0;
            if(!this.summaryOrder) {
                return 0;
            }
            switch (status) {
                case 0:
                    total = this.summaryOrder.TotalStatus1;
                    break;
                case 1:
                    total = this.summaryOrder.TotalStatus2;
                    break;
                case 2:
                    total = this.summaryOrder.TotalStatus3;
                    break;
                case 3:
                    total = this.summaryOrder.TotalStatus4;
                    break;
                case 4:
                    total = this.summaryOrder.TotalStatus5;
                    break;
                case 5:
                    total = this.summaryOrder.TotalStatus6;
                    break;
                default:
                    total = this.summaryOrder.TotalStatusAll;
                    break;
            }
            total = total ? total : 0;
            if(total < 999 || !format) {
                return total.toLocaleString('en-US');
            }
            return (Math.floor(total / 1000)).toLocaleString('en-US') + 'K';
        }
}
